'use client';

var DEFAULT_OPTION = {
    isCloseOnClickBackdrop: true,
    isHaveCloseIcon: true
};
var DEFAULT_FOOTER_OTPION = {
    text: 'Ok',
    buttonType: 'primary',
    isCloseOnClick: true,
    callbackOnClick: function () { }
};

export { DEFAULT_FOOTER_OTPION, DEFAULT_OPTION };
//# sourceMappingURL=constants.js.map
